// The screens' calls to /api/team (getAuthHeaders, never a hand-built key) for the commercial team of the central base.
import { getAuthHeaders, CURRENT_USER } from './globals.js';
import { teamErrorText, matchText } from './teamMessages.js';

export async function teamCall(body) {
  let res;
  try { res = await fetch('/api/team', { method: 'POST', headers: getAuthHeaders(), body: JSON.stringify(body) }); }
  catch { throw Object.assign(new Error('No hubo conexión con Oike: revisá tu red y volvé a intentarlo.'), { code: 'network' }); }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(teamErrorText(data) || `No se pudo completar (${data.error || res.status}).`), { code: data.error || '', data, status: res.status });
  return data;
}

export const isTeamMode = () => !!CURRENT_USER?.teamMode;

/**
 * Before creating (or changing the email, LinkedIn or website of) a contact or a company, for the team of the central
 * base: a reliable duplicate stops it with its reason; a similar name asks for confirmation. Returns true to go on.
 * Admins keep the check they already had in the browser (they see every record). The server blocks reliable
 * duplicates anyway (airtable-proxy), so this only says it earlier and in plain words.
 */
export async function confirmNoDuplicate(kind, fields, excludeId = '') {
  if (!isTeamMode()) return true;
  let results;
  try { ({ results } = await teamCall({ action: 'checkDuplicate', kind, fields, excludeId })); }
  catch (e) { window.alert(`No se pudo comprobar si ya existe: ${e.message} No se creó nada.`); return false; }
  const ms = results?.[0] || [];
  const block = ms.find(m => m.level === 'block');
  if (block) { window.alert(matchText(block)); return false; }
  const warns = ms.filter(m => m.level === 'warn');
  if (!warns.length) return true;
  return window.confirm(`Puede que ya exista:\n\n${warns.slice(0, 3).map(m => `• ${matchText(m)}`).join('\n')}\n\nUn nombre parecido no prueba que sea el mismo. ¿Lo creás igual?`);
}
